var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 592.6 447.6",
    style: {
      enableBackground: "new 0 0 592.6 447.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.9,367.5c-19.9,18.8-40.4,38.2-61,57.6c-2.2,2.1-4.7,3.7-6.8,5.9c-13.6,14.1-30.6,17.4-49.4,16.4 c-27.8-1.5-54.6-8.1-81.4-14.8c-28.7-7.1-57.4-14.8-86.3-21c-23.3-5-47-6.6-69.9,2.4c-9.2,3.6-17.9,8.6-27.6,13.3 C44.8,395,22.6,361.9,0,328.1c7.8-7.3,15.5-14.9,23.6-22c22.6-20.1,48-35.5,77.3-43.2c10.3-2.7,21.4-4,32.1-3.8 c26.3,0.5,52.2-1.4,77.7-8c29.8-7.7,56.2,0.8,80.8,17.5c12.6,8.6,25.3,17.3,38.6,24.8c12.9,7.2,27.3,10.1,42.2,10.6 c27.3,0.9,54.6,1.8,81.8,4.1c12.9,1.1,25.6,5.5,38.2,9.1c3.9,1.1,7.8,4,10.7,7c8.2,8.4,6.7,19.7-3.4,25.8 c-10.1,6.1-21.2,9.5-32.9,10.9c-19.4,2.4-38.6-0.7-57.7-3.6c-26.9-4-53.9-6.7-81.1-2.6c-17.4,2.7-34,8-49.8,15.8 c-1.3,0.6-1.9,2.5-2.9,3.8c1.7,0.2,3.8,1,5.1,0.4c15.2-7,30.9-12.3,47.5-14.9c18.6-3,37.2-2.8,55.8-0.6 C405.9,361.8,427.9,364.8,448.9,367.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.6,30.7c13.9-15.4,29.9-24.9,49.2-28.9c51.9-10.7,98.1,28.9,95.6,82c-0.9,18.8-7.4,35.7-17.1,51.5 c-14,22.7-32.3,42-51.6,60.1c-25,23.5-50.4,46.5-75.9,70c0.1,0-0.4,0-0.8-0.3c-25.8-24.1-51.8-48-77.4-72.3 c-18.6-17.7-36.1-36.5-49.5-58.6c-12.1-19.9-18.5-41.1-16.1-64.7c3.4-34.4,32.2-64.4,66.5-68.7c29.8-3.7,54.7,5.8,75.4,27.2 C360.5,28.7,360.8,29.5,361.6,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.9,302.5c5-3.3,9.4-7.4,14.6-9.4c17.7-6.9,32.8-17.5,47.4-29.3c13.5-10.9,28.6-16.3,46.1-11.8 c6.9,1.8,13.1,4.7,18.7,11.6c-26.7,22.6-53.3,45.1-80.4,68c-4.7-9.2-11.1-15.8-19.6-19.5C484.3,308.5,475.6,306,465.9,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534.1,232.7c-23.6,16.3-47.3,32.5-70.7,49.1c-7.7,5.4-14.6,12-21.9,18c-1.2,1-2.7,2.2-4.1,2.3 c-7.9,0.6-15.9,0.9-24.4,0.3c3.7-3.1,7.4-6.3,11.1-9.4c16.7-13.8,33.5-27.3,50-41.3c11.6-9.8,23.7-18.5,39.3-20.1 c6.8-0.7,13.7-0.1,20.5-0.1C534,231.9,534,232.3,534.1,232.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M446.7,300.8c5.4-4.3,10.7-8.8,16.3-12.8c19.1-13.6,38.3-27,57.4-40.6c10-7.1,20.4-13.2,32.8-14.9 c7.5-1,14.7-0.3,21,4c1.2,0.8,2.5,3.6,2,4.5c-1.3,2.3-1.7,6.4-5.8,5.6c-16.8-3.1-31.1,2.6-44.2,12.4c-3.2,2.4-6.4,4.8-9.5,7.3 c-10.2,8.5-21.3,15.3-33.6,20.2c-8.2,3.3-15.8,7.7-21.5,14.9c-0.7,0.9-2.2,1.5-3.3,1.5c-3.6,0-7.3-0.4-10.9-0.7 C447.2,301.7,447,301.2,446.7,300.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/iconSupport.f61cd0f2eb166c4704b72843727b42a5.svg";
export { ForwardRef as ReactComponent };